<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Mail Accounts</h2>
            <div>
                <el-button type="primary" size="small" @click="onShowAdd">Add Account</el-button>
            </div>
        </div>
        <div class="page-section">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="from_name" label="From Name" width="200"/>
                <el-table-column prop="from_address" label="From Address"/>
                <el-table-column width="80" :label="$t('common.option')" align="right">
                    <template slot-scope="scope">
                        <a @click="onShowEdit(scope.row)">{{ $t('common.edit') }}</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablenav-bottom">
                <div class="table-actions">
                    <el-button size="small" type="primary" :disabled="selectionIds.length===0" @click="onDelete">
                        {{ $t('common.batch_delete') }}
                    </el-button>
                </div>
                <el-pagination
                        background
                        layout="prev, pager, next, total"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="page"
                        @current-change="onPageChange"
                />
            </div>
        </div>

        <el-dialog title="Edit Mail Config" closeable :visible.sync="showDialog" :close-on-click-modal="false"
                   :close-on-press-escape="false" width="60%">
            <el-form label-width="160px">
                <el-form-item :label="$t('settings.mail_from_name')">
                    <el-input class="w300" v-model="config.from_name"/>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_from_address')">
                    <el-input class="w300" v-model="config.from_address"/>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_host')">
                    <el-input class="w300" v-model="options.mail_host"/>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_port')">
                    <el-input class="w100" v-model="options.mail_port"/>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_encryption')">
                    <el-radio-group v-model="options.mail_encryption">
                        <el-radio label="">{{ $t('settings.mail_encryption_none') }}</el-radio>
                        <el-radio label="ssl">{{ $t('settings.mail_encryption_ssl') }}</el-radio>
                        <el-radio label="tls">{{ $t('settings.mail_encryption_tls') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_username')">
                    <el-input class="w300" v-model="options.mail_username"/>
                </el-form-item>
                <el-form-item :label="$t('settings.mail_password')">
                    <el-input type="password" class="w300" v-model="options.mail_password"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="onSubmit">{{ $t('settings.save') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </main-layout>
</template>

<script>
import ApiService from "../utils/ApiService";
import Pagination from "../mixins/Pagination";

export default {
    name: "MailAccountList",
    mixins: [Pagination],
    data() {
        return {
            config: {},
            options: {},
            showDialog: false
        }
    },
    methods: {
        listApi() {
            return '/buildium/mail-configs';
        },
        resetData() {
            this.config = {
                id: null,
                from_name: '',
                form_address: ''
            };
            this.options = {
                mail_host: 'smtp.office365.com',
                mail_port: '587',
                mail_encryption: 'tls',
                mail_username: '',
                mail_password: ''
            };
        },
        onDelete() {
            let ids = this.selectionIds.map((d) => d.id);
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                ApiService.delete('/buildium/mail-configs/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                    this.$message.success(this.$t('Delete success'));
                }).catch((reason) => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.selectionIds = [];
                });
            });
        },
        onSubmit() {
            let {config, options} = this;
            if (!config.from_name) {
                this.$message.error('From name required');
                return false;
            }

            if (config.id) {
                ApiService.put('/buildium/mail-configs/' + config.id, {
                    ...config,
                    options
                }).then(() => {
                    this.showDialog = false;
                    this.resetData();
                    this.fetchList();
                    this.$message.success('Update success');
                });
            } else {
                ApiService.post('/buildium/mail-configs', {
                    ...config,
                    options
                }).then(() => {
                    this.showDialog = false;
                    this.resetData();
                    this.fetchList();
                    this.$message.success('Create success');
                });
            }
        },
        onShowAdd() {
            this.resetData();
            this.showDialog = true;
        },
        onShowEdit(d) {
            this.config = d;
            this.options = d.options;
            this.showDialog = true;
        },
        onSelectionChange(val) {
            this.selectionIds = val;
        }
    },
    mounted() {
        this.fetchList();
    },
}
</script>

<style scoped>

</style>
